import moment from "moment";
import React, { useEffect, useState } from "react";

const InvoicePdfFormat = ({ orderDetails, data, setCounter }) => {
  const [templateData, setTemplateData] = useState();
  const [isDisplay, setIsDisplay] = useState(false);

  // Utility function to normalize state names
  const normalizeStateName = (state) => {
    if (!state) return "";
    return state.trim().toUpperCase().replace(/\s+/g, "");
  };

  // GST Calculation Function
  const calculateGSTBreakdown = (
    clientState,
    customerState,
    totalAmount,
    ProductSelfGst
  ) => {
    // Normalize state names for comparison
    const normalizedClientState = normalizeStateName(clientState);
    const normalizedCustomerState = normalizeStateName(customerState || "");

    // Initialize GST variables
    let cgstAmount = 0;
    let sgstAmount = 0;
    let igstAmount = 0;
    let cgstPercent = 0;
    let sgstPercent = 0;
    let igstPercent = 0;
    let gstType = "";

    console.log("----------------ProductSelfGst:", ProductSelfGst);

    // Convert total amount to number and ensure it's a valid number
    const numericTotalAmount = parseFloat(totalAmount) || 0;

    // Check if states are the same (intra-state supply)
    if (
      normalizedClientState === normalizedCustomerState &&
      ProductSelfGst != null &&
      ProductSelfGst != "" &&
      !isNaN(ProductSelfGst)
    ) {
      // Intra-state supply - apply CGST and SGST
      const calculate_test_percent = ProductSelfGst / 2;
      cgstPercent = calculate_test_percent;
      sgstPercent = calculate_test_percent;
      gstType = "CGST+SGST";
      // cgstAmount = (numericTotalAmount * calculate_test_percent) / 100; // 9% CGST
      // sgstAmount = (numericTotalAmount * calculate_test_percent) / 100; // 9% SGST

      let base_amount = numericTotalAmount / (1 + ProductSelfGst/100)
      let gst_amount = numericTotalAmount - base_amount
      cgstAmount = gst_amount/2
      sgstAmount = gst_amount/2
    } else if (
      ProductSelfGst != null &&
      ProductSelfGst != "" &&
      !isNaN(ProductSelfGst)
    ) {
      // Inter-state supply - apply IGST
      igstPercent = ProductSelfGst;
      gstType = "IGST";
      // igstAmount = (numericTotalAmount * ProductSelfGst) / 100; // 18% IGST

      let base_amount = numericTotalAmount / (1 + ProductSelfGst/100)
      igstAmount = numericTotalAmount - base_amount
    }

    return {
      gstType,
      cgstAmount: cgstAmount.toFixed(2),
      sgstAmount: sgstAmount.toFixed(2),
      igstAmount: igstAmount.toFixed(2),
      cgstPercent: cgstPercent,
      sgstPercent: sgstPercent,
      igstPercent: igstPercent,
      totalGST: (cgstAmount + sgstAmount + igstAmount).toFixed(2),
    };
  };

  // Convert number to words
  const numberToWords = (num) => {
    const a = [
      "",
      "One ",
      "Two ",
      "Three ",
      "Four ",
      "Five ",
      "Six ",
      "Seven ",
      "Eight ",
      "Nine ",
      "Ten ",
      "Eleven ",
      "Twelve ",
      "Thirteen ",
      "Fourteen ",
      "Fifteen ",
      "Sixteen ",
      "Seventeen ",
      "Eighteen ",
      "Nineteen ",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    if ((num = num.toString()).length > 9) return "Overflow";

    const n = ("000000000" + num)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return "";

    let str = "";
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore "
        : "";
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh "
        : "";
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand "
        : "";
    str +=
      n[4] != 0
        ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred "
        : "";
    str +=
      n[5] != 0
        ? (str != "" ? "and " : "") +
          (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
          "Only "
        : "";

    return str;
  };

  useEffect(() => {
    if (data?.templateData) {
      const customerName = orderDetails?.customerDetails?.customerName;
      const totalPrice =
        +orderDetails?.unitPrice * +orderDetails?.qty +
        (+orderDetails?.orderDetails?.shippingAmount || 0);
      const paymentNo =
        orderDetails?.orderDetails?.orderNo +
        "-" +
        orderDetails?.orderDetails?.id;
      const paymentDate = orderDetails?.orderDetails?.orderDate
        ? moment(orderDetails?.orderDetails?.orderDate, "YYYY-MM-DD").format(
            "DD-MM-YYYY"
          )
        : "";
      const clientCompanyName = orderDetails?.clientDetails?.companyName;
      const clientAddress = orderDetails?.clientDetails?.address;
      const clientCity = "Vadodara";
      const clientState = "GUJARAT";
      const clientPincode = "391101";
      const clientGSTIN = "24AAKCK0496K1Z7";
      const clientEmail = "k9.vadodara@gmail.com";
      const invoiceDate = moment().format("DD-MM-YYYY");
      const invoiceNo = "INV_K9_PO_" + orderDetails?.orderDetails?.orderNo;
      const paymentMode = orderDetails?.orderDetails?.paymentType;
      const customerAddress =
        orderDetails?.shippingAddress?.[0]?.customerAddress;
      const customerCity = orderDetails?.shippingAddress?.[0]?.customerCity;
      const customerState = orderDetails?.shippingAddress?.[0]?.customerState;
      const customerPincode =
        orderDetails?.shippingAddress?.[0]?.customerPincode;
      const productName =
        orderDetails?.productDetails?.productDetail?.productname;
      const qty = orderDetails?.qty;
      const productPrice = orderDetails?.unitPrice;
      let subTotal = 0;
      if (
        orderDetails?.purchaseDiscountedPercentage !==
          null &&
        orderDetails?.purchaseDiscountedPercentage !== ""
      ) {
        // let disAmount =
        //   (+orderDetails?.unitPrice *
        //     parseFloat(
        //       orderDetails?.productDetails?.productDetail?.discountedPercentage
        //     )) /
        //   100;
        // let finalSub = +orderDetails?.unitPrice - disAmount;
        subTotal = parseFloat(orderDetails?.purchaseUnitPrice) * +orderDetails?.qty;
        console.log('unitprice0104: ', parseFloat(orderDetails?.purchaseUnitPrice));
        console.log('subTotal0104: ', subTotal);

      } else {
        subTotal = parseFloat(orderDetails?.purchaseUnitPrice) * +orderDetails?.qty;
      }
      let unitRate = 0;
      if (
        orderDetails?.purchaseDiscountedPercentage !== null && orderDetails?.purchaseDiscountedPercentage !== ""
      ) {
        let finalunitSub = parseFloat(orderDetails?.purchaseUnitPrice);
        unitRate = finalunitSub;
      } else {
        unitRate = parseFloat(orderDetails?.purchaseUnitPrice);
      }

      const shippingCharges = +orderDetails?.orderDetails?.shippingAmount || 0;
      const customerMobileNo =
        +orderDetails?.customerDetails?.customerMobile || 0;
      const discount = 0;
      const variantName =
        orderDetails?.productDetails?.variantDetail?.variantkey;

      const ProductSelfGst = parseFloat(
        orderDetails?.productDetails?.productDetail?.gst
      );

      const shippingDeliveryAmount = parseFloat(
        orderDetails?.shippingDeliveryAmount
      );
      // // GST Calculation
      // const gstBreakdown = calculateGSTBreakdown(
      //   clientState,
      //   customerState,
      //   subTotal,
      //   ProductSelfGst
      // );
      // console.log("cgstAmount:", gstBreakdown.cgstAmount);
      // console.log("sgstAmount:", gstBreakdown.sgstAmount);
      // console.log("igstAmount:", gstBreakdown.igstAmount);

      // let updated_final_subTotal = 0;
      // if (
      //   (gstBreakdown.cgstAmount != 0.0 && gstBreakdown.sgstAmount != 0.0) ||
      //   gstBreakdown.igstAmount != 0.0
      // ) {
      //   console.log('unitprice0104: ', parseFloat(orderDetails?.purchaseUnitPrice));
      //   console.log('subTotal0104: ', subTotal);
      //   // Calculate subtotal without gst
      //   updated_final_subTotal = (
      //     (parseFloat(orderDetails?.purchaseUnitPrice) - gstBreakdown.cgstAmount - gstBreakdown.sgstAmount - gstBreakdown.igstAmount)*+orderDetails?.qty).toFixed(2);
      //   console.log('updated_final_subTotal: ', updated_final_subTotal);
      //   unitRate = (
      //     parseFloat(orderDetails?.purchaseUnitPrice) -
      //     gstBreakdown.cgstAmount -
      //     gstBreakdown.sgstAmount -
      //     gstBreakdown.igstAmount
      //   ).toFixed(2);
      //   console.log('unitRate0104: ', unitRate);
        
      // } else {
      //   updated_final_subTotal = subTotal;
      //   unitRate = subTotal;
      // }

      // // Calculate Grand Total
      // const grandTotal = (parseFloat(updated_final_subTotal) + parseFloat(shippingDeliveryAmount)).toFixed(2);

      // // Convert Grand Total to Words
      // const amountInWords = numberToWords(Math.round(grandTotal));

  // ##################### New Calculation ####################

    //--------------- calculation for single unit -----------------//
      const withGSTSingleUnitPrice = parseFloat(orderDetails?.purchaseUnitPrice)
      const gstBreakdownForSingleUnit = calculateGSTBreakdown(
        clientState,
        customerState,
        withGSTSingleUnitPrice,
        ProductSelfGst
      );
      let withOutGSTSingleUnitPrice = 0
      if (
        (gstBreakdownForSingleUnit.cgstAmount != 0.0 && gstBreakdownForSingleUnit.sgstAmount != 0.0) ||
        gstBreakdownForSingleUnit.igstAmount != 0.0
      ) {
        withOutGSTSingleUnitPrice = (parseFloat(orderDetails?.purchaseUnitPrice) - gstBreakdownForSingleUnit.cgstAmount -
        gstBreakdownForSingleUnit.sgstAmount -
        gstBreakdownForSingleUnit.igstAmount).toFixed(2)
      }
      else{
        withOutGSTSingleUnitPrice = (parseFloat(orderDetails?.purchaseUnitPrice).toFixed(2))
      }

    //--------------- calculation for Multiple unit -----------------//
    const withGSTAvailableUnitPrice = parseFloat(orderDetails?.purchaseUnitPrice) * +orderDetails?.qty
    const gstBreakdownForAvailableUnit = calculateGSTBreakdown(
      clientState,
      customerState,
      withGSTAvailableUnitPrice,
      ProductSelfGst
    );
    let withOutGSTAvailableUnitPrice = 0
    let lastPrice = 0
    if (
      (gstBreakdownForAvailableUnit.cgstAmount != 0.0 && gstBreakdownForAvailableUnit.sgstAmount != 0.0) ||
      gstBreakdownForAvailableUnit.igstAmount != 0.0
    ) {
      withOutGSTAvailableUnitPrice = (parseFloat(withGSTAvailableUnitPrice) - gstBreakdownForAvailableUnit.cgstAmount -
      gstBreakdownForAvailableUnit.sgstAmount -
      gstBreakdownForAvailableUnit.igstAmount).toFixed(2)
      lastPrice = (withGSTAvailableUnitPrice + parseFloat(shippingDeliveryAmount)).toFixed(2)
    }
    else{
      withOutGSTAvailableUnitPrice = (parseFloat(withGSTAvailableUnitPrice).toFixed(2))
      lastPrice = (withOutGSTAvailableUnitPrice + parseFloat(shippingDeliveryAmount)).toFixed(2)
    }
    const amountInWords = numberToWords(Math.round(lastPrice));



      const renderHTML = () => {
        if (gstBreakdownForAvailableUnit.igstAmount != 0.0) {
          return `<tr class="total-row">
              <td colspan="5" align="right">
                IGST ${gstBreakdownForAvailableUnit.igstPercent}%
              </td>
              <td>${gstBreakdownForAvailableUnit.igstAmount}</td>
            </tr>`;
        } else {
          return `<tr class="total-row">
                <td colspan="5" align="right">
                  CGST ${gstBreakdownForAvailableUnit.cgstPercent}%
                </td>
                <td>${gstBreakdownForAvailableUnit.cgstAmount}</td>
              </tr>
              <tr class="total-row">
                <td colspan="5" align="right">
                  SGST ${gstBreakdownForAvailableUnit.sgstPercent}%
                </td>
                <td>${gstBreakdownForAvailableUnit.sgstAmount}</td>
              </tr>`;
        }
      };

      const replacedHtmlCode = data.templateData
        .replace(/{customerName}/g, customerName)
        .replace(/{totalPrice}/g, totalPrice)
        .replace(/{paymentNo}/g, paymentNo)
        .replace(/{invoiceNo}/g, paymentNo)
        .replace(/{paymentDate}/g, paymentDate)
        .replace(/{clientCompanyName}/g, clientCompanyName)
        .replace(/{clientAddress}/g, clientAddress)
        .replace(/{clientCity}/g, clientCity)
        .replace(/{clientState}/g, clientState)
        .replace(/{clientPincode}/g, clientPincode)
        .replace(/{customerAddress}/g, customerAddress)
        .replace(/{customerMobileNo}/g, customerMobileNo)
        .replace(/{customerCity}/g, customerCity)
        .replace(/{customerState}/g, customerState)
        .replace(/{customerPincode}/g, customerPincode)
        .replace(/{productName}/g, productName)
        .replace(/{qty}/g, qty)
        .replace(/{productPrice}/g, productPrice)
        .replace(/{subTotal}/g, withOutGSTAvailableUnitPrice)
        .replace(/{shippingCharges}/g, shippingCharges)
        .replace(/{discount}/g, discount)
        .replace(/{clientGSTIN}/g, clientGSTIN)
        .replace(/{invoiceDate}/g, invoiceDate)
        .replace(/{invoiceNo}/g, invoiceNo)
        .replace(/{paymentMode}/g, paymentMode)
        .replace(/{unitRate}/g, withOutGSTSingleUnitPrice)
        .replace(/{variantName}/g, variantName)
        .replace(/{clientEmail}/g, clientEmail)
        .replace(/{cgstAmount}/g, gstBreakdownForAvailableUnit.cgstAmount)
        .replace(/{sgstAmount}/g, gstBreakdownForAvailableUnit.sgstAmount)
        .replace(/{igstAmount}/g, gstBreakdownForAvailableUnit.igstAmount)
        .replace(/{isIGSTApplicable}/g, renderHTML())
        .replace(/{cgstPercent}/g, gstBreakdownForAvailableUnit.cgstPercent)
        .replace(/{sgstPercent}/g, gstBreakdownForAvailableUnit.sgstPercent)
        .replace(/{igstPercent}/g, gstBreakdownForAvailableUnit.igstPercent)
        .replace(/{grandTotal}/g, lastPrice)
        .replace(/{amountInWords}/g, amountInWords)
        .replace(/{shippingDeliveryAmount}/g, shippingDeliveryAmount);
      setTemplateData(replacedHtmlCode);
      setIsDisplay(true);
    }
  }, [data?.templateData]);
  const handleDownload = (elementId) => {
    const element = document.getElementById("pdfForm");
    const options = {
      filename: `${data?.templateName}-${Date.now()}.pdf`,
      html2canvas: { scale: 4 },
      margin: 5,
    };

    window
      .html2pdf()
      .set({
        margin: [10, 10, 10, 10],
        padding: [5, 5, 5, 5],
        filename: `${data?.templateName}-${Date.now()}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 4.5 },
        autoPaging: "text",
        jsPDF: {
          autoPaging: "text",
          unit: "mm",
          format: "A4",
          orientation: "portrait",
          margin: { top: 10, bottom: 100 },
        },
      })
      .from(element)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        var blob = new Blob([pdf.output("blob")], { type: "application/pdf" });
        var url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      });
    setCounter(0);
  };

  useEffect(() => {
    if (isDisplay) {
      handleDownload();
    }
    // eslint-disable-next-line
  }, [isDisplay]);

  return (
    <div style={{ display: "none" }}>
      <div
        id="pdfForm"
        style={{ color: "black", margin: 0, padding: 5 }}
        className=""
        dangerouslySetInnerHTML={{
          __html: templateData,
        }}
      />
    </div>
  );
};

export default InvoicePdfFormat;
